import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { Checkbox } from "@blueprintjs/core";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useHistory } from "react-router-dom";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";
import "./DividendProcess.scss"

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { AcCodeInfo, CurrencyInfo } from './Types'
import { SystemHeader, ClientPicker } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;



interface Conv_Int2BalMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function Conv_Int2BalMain({ gsb }: Conv_Int2BalMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    const history = useHistory()

    const [searchKey, setSearchKey] = useState("StkNo")

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkNo, setsearchStkNo] = useState("")
    const [showButton, setshowButton] = useState(true)
    const [ShowWait, setShowWait] = useState(false)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")

    const [CurrencyList, setCurrencyList] = useState([] as CurrencyInfo[])
    const [CurrencyList2, setCurrencyList2] = useState([] as CurrencyInfo[])

    const [AcCodeValue, setAcCodeValue] = useState("")
    const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcCodeList, setAcCodeList] = useState([] as AcCodeInfo[])
    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")
    const [AcStatusValue, setAcStatusValue] = useState("")
    const [CurrencyValue, setCurrencyValue] = useState("")
    const [AmountValue, setAmountValue] = useState("0")
    const [PrevDayValue, setPrevDayValue] = useState(0)
    const [LatestBalValue, setLatestBalValue] = useState(0)
    const [UnClrChqValue, setUnClrChqValue] = useState(0)
    const [InterestValue, setInterestValue] = useState(0)
    const [DescValue, setDescValue] = useState("Interest to Balance")
    

    const [currentMode, setcurrentMode] = useState("show")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")
    const [dateFormat, setdateFormat] = useState("")

    const [DEF_ThemeNo, setDEF_ThemeNo] = useState("1")


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("Conv_Int2BalMain disp user_key: ", res.data.Flag.user_key)
                //console.log("Conv_Int2BalMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("Conv_Int2BalMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("Conv_Int2BalMain disp GsbFlag: ", GsbFlag)
                //console.log("Conv_Int2BalMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("Conv_Int2BalMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("Conv_Int2BalMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("Conv_Int2BalMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("Conv_Int2BalMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                if ( GsbFlag.isProduction == "Y" ) {
                    setDEF_ThemeNo(GsbFlag.DEF_THEME1);
                } else {
                    setDEF_ThemeNo(GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setdateFormat(GsbFlag.dateFormat);
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                //console.log("Conv_Int2BalMain PayRec.d_acCode: ", PayRec.d_acCode, AcCodeValue) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACBalInfo", cAcCode: AcCodeValue, CCY: CurrencyValue})
                //console.log("Conv_Int2BalMain GetACInfo data : ", res.data.data) 
                //console.log("Conv_Int2BalMain GetACInfo  count: ", res.data.count) 
                
                if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setPrevDayValue(res.data.data[0].acbal_PrevDay) 
                    setLatestBalValue(res.data.data[0].acbal_LatestBal) 
                    setUnClrChqValue(res.data.data[0].acbal_UnClrChq) 
                    setInterestValue(res.data.data[0].acbal_Interest)
                    setAcName1Value(res.data.data[0].d_acName1)
                    setAcName2Value(res.data.data[0].d_acName2)
                    setAcStatusValue(res.data.data[0].d_status)

                    let LatestBalValue2 = res.data.data[0].acbal_LatestBal

                    setLatestBalValue(LatestBalValue2)
                } else { 
                    setPrevDayValue(0)
                    setLatestBalValue(0)
                    setUnClrChqValue(0)
                    setInterestValue(0)
                    setAcName1Value("")
                    setAcName2Value("")
                    setAcStatusValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue, CurrencyValue])

    useEffect(() => {
        (async () => {
            try {
                // get Market List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "ExchangeRate", cAction: "GetCCYList"})

                //console.log("MarketList: ", res.data.data) 
                CurrencyList2.push({d_Currency: "", d_CcyDesc: "HKD"})
                for (let j = 0; j < res.data.data.length; j++) {
                    CurrencyList2.push({d_Currency: res.data.data[j][0], d_CcyDesc: res.data.data[j][1]})
                }
                setCurrencyList(CurrencyList2)
                //console.log("set CurrencyList: ", CurrencyList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    const CurrencyRenderer: ItemRenderer<CurrencyInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${CurrencyList.d_CcyDesc}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CurrencyList.d_Currency}
                key={CurrencyList.d_Currency}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const CurrencyPredicate: ItemPredicate<CurrencyInfo> = (query, CurrencyList, _index, exactMatch) => {
        const normalizedText = `${CurrencyList.d_Currency} - ${CurrencyList.d_CcyDesc}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const CurrencyValueRenderer = (CurrencyList: CurrencyInfo) => {
        return CurrencyList.d_Currency
    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }


    const onSubmit = (e: React.KeyboardEvent<HTMLFormElement>) => {
        e.preventDefault()

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
    }

    const onGeneratePRTran = () => {
        setShowWait(true)
        setshowButton(false)
        ;


        (async () => {
            ;
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: {
                        s_AcCodeValue: AcCodeValue,
                        s_CurrencyValue: CurrencyValue,
                        s_AmountValue: AmountValue,
                        s_DescValue: DescValue,
                    }, 
                    cPgmId: "PayRecTranEntry",
                    cAction: "GenerateInt2BalPRTran",
                })                
                if ( res.data.ok ) {
                    utils.showSuccess(res.data.data)
                } else {
                    utils.showWarn(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()


        setShowWait(false)
        setshowButton(true)
    }
    
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <ClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setClCodeValue(ac.d_acCode); setIsClPickerOpen(false)}}/>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <div>
                        <H3>Convert Interest to Balance</H3>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                            <InputGroup id="inputacCode" autoFocus value={AcCodeValue} placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase())) }  
                                rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setSetClCodeValue(()=>setAcCodeValue); setIsClPickerOpen(true)}}></Button>}
                            />
                        </FormGroup>
                        <FormGroup className="Col-3-3" label="Client Name" labelFor="inputAcName1">
                            <div>
                            <div id="DispText">{AcName1Value}</div>
                            <div id="DispText">{AcName2Value}</div>
                            </div>
                        </FormGroup>
                        <FormGroup className="Col-6-1" label="Status" >
                            <div>
                            <div id="DispText">{AcStatusValue}</div>
                            </div>
                        </FormGroup>
                        <FormGroup className="Col-7-3" label="Outstanding Balance">
                            <div>
                            <div id="DispText">Prev. Day : {utils.formatNumber3(PrevDayValue, 2)}</div>
                            <div id="DispText">   Latest : {utils.formatNumber3(LatestBalValue, 2)}</div>{ (LatestBalValue < 0) && <div style={{color:DEF_ThemeNo=="5 "?"Green":"red"}}>**  Debit Balance **</div>}
                            <div id="DispText">Unclr Chq : {utils.formatNumber3(UnClrChqValue, 2)}</div>
                            <div id="DispText">Interest : {utils.formatNumber3(InterestValue, 2)}</div>
                            </div>
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col3-1-1" label="Currency" labelFor="inputCurrency" labelInfo="*">
                            <Suggest2
                                    inputProps={{ placeholder: "Currency ..." }}
                                    activeItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                                    selectedItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                                    items={CurrencyList}
                                    itemRenderer={CurrencyRenderer}
                                    itemPredicate={CurrencyPredicate}
                                    inputValueRenderer={CurrencyValueRenderer}
                                    onItemSelect={(PayRec) => { setCurrencyValue(PayRec.d_Currency) }}
                                />
                        </FormGroup>
                        <FormGroup className="Col-2-2" label="Amount" labelFor="inputAmount">
                            <InputGroup className="inputNumberNoSpin" id="inputAmount" value={AmountValue} onChange={utils.handleStringChange(n => setAmountValue(n))}  />
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-5" label="Description" labelFor="inputDescription">
                            <InputGroup id="inputDescription" value={DescValue} placeholder="Description ..." onChange={utils.handleStringChange(s => setDescValue(s)) } />
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <Button disabled={! showButton} className="Col-1-1" icon="confirm" onClick={() => { onGeneratePRTran() } }>Generate</Button> 
                    </div>
                    <div className="Spacing-V-16" />
                    {ShowWait && <div>{imgWait}</div> }
                    <div>
                        <div className="Spacing-V-16"></div>
                        <div >Note : </div>
                        <div >If interest is -ve , use +ve amount to settle it</div>
                        <div >If interest is +ve , use -ve amount to settle it</div>
                    </div>
                </Card>
            </form>
        </>
    );
}

export default Conv_Int2BalMain